import ConstantHelper from "../../Helpers/ConstantHelper";

const BrandingPackagesData = [
  {
    id: "1",
    title: "Premium Collateral Packages",
    overview:
      "Suitable for potential startups and brand revamps for companies.",
    offerPrice: "200",
    actualPrice: "400",
    featuresList: [
      { feature: "2 Stationery Design Set" },
      { feature: "Packaging Design" },
      { feature: "2 Rounds of Revisions" },
      { feature: "T-Shirt Design" },
    ],
    orderNowBtn: true,
    viewDetailsBtn: true,
    CTACall: ConstantHelper.CTACall,
    CTAChat: ConstantHelper.CTAChat,
  },
  {
    id: "2",
    title: "Elite Collateral Bundle",
    overview:
      "Suitable for potential startups and brand revamps for companies.",
    offerPrice: "250",
    actualPrice: "500",
    featuresList: [
      { feature: "2 Stationery Design Set" },
      { feature: "Menu Card Design" },
      { feature: "T-Shirt Design" },
      { feature: "1 Banner Design" },
    ],
    orderNowBtn: true,
    viewDetailsBtn: true,
    CTACall: ConstantHelper.CTACall,
    CTAChat: ConstantHelper.CTAChat,
  },
  {
    id: "3",
    title: "Complete Branding Solution",
    overview:
      "Suitable for potential startups and brand revamps for companies.",
    offerPrice: "995",
    actualPrice: "1990",
    featuresList: [
      { feature: "3 Initial Logo Concepts" },
      { feature: "6 Dedicated Designers" },
      { feature: "Up to 10 Unique Pages Website" },
      { feature: "Mobile Responsive" },
      { feature: "Icon Design" },
      { feature: "Business Card, Letterhead, Envelope" },
      { feature: "MS Word Letterhead" },
      { feature: "5 Stock Photos + 3 Banner Designs" },
      { feature: "Complete W3C Certified HTML" },
      { feature: "Complete Deployment" },
      { feature: "Facebook Page Design" },
      { feature: "All Final File Formats" },
      { feature: "Dedicated Account Manager" },
      { feature: "100% Ownership Rights" },
      { feature: "100% Unique Design Guarantee" },
      { feature: "100% Money Back Guarantee" },
    ],
    orderNowBtn: true,
    viewDetailsBtn: true,
    CTACall: ConstantHelper.CTACall,
    CTAChat: ConstantHelper.CTAChat,
  },
  {
    id: "4",
    title: "Startup Collateral Packages",
    overview:
      "Suitable for potential startups and brand revamps for companies.",
    offerPrice: "50",
    actualPrice: "100",
    featuresList: [
      { feature: "2 Stationery Design Set" },
      { feature: "FREE Fax Template" },
      { feature: "Print Ready Formats" },
      { feature: "2 Rounds of Revisions" },
    ],
    orderNowBtn: true,
    viewDetailsBtn: true,
    CTACall: ConstantHelper.CTACall,
    CTAChat: ConstantHelper.CTAChat,
  },
  {
    id: "5",
    title: "Collateral Classic Packages",
    overview:
      "Suitable for potential startups and brand revamps for companies.",
    offerPrice: "130",
    actualPrice: "260",
    featuresList: [
      { feature: "2 Stationery Design Set" },
      { feature: "2 Rounds of Revisions" },
      { feature: "Flyer Design" },
      { feature: "Brochure Design (Bi-fold/Tri-fold)" },
    ],
    orderNowBtn: true,
    viewDetailsBtn: true,
    CTACall: ConstantHelper.CTACall,
    CTAChat: ConstantHelper.CTAChat,
  },
];

// The tiers that include a stationery design set, for the Stationery service page.
export const CollateralPackagesData = BrandingPackagesData.filter((pkg) =>
  pkg.featuresList.some((f) => /stationery design set/i.test(f.feature))
);

export default BrandingPackagesData;
